export default {
  Loading: 'Cargando...',
  search: 'Buscar...',
  noMessages: 'No hay mensajes',
  noSearchResults: 'No se han encontrado registros que coincidan',
};
